const QUEUE_KEY = 'nofodesk_offline_queue_v1';

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '{}'); }
  catch { return {}; }
}

export function queueSync(endpoint, records) {
  try {
    const q = getQueue();
    q[endpoint] = { records, queuedAt: Date.now() };
    localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
  } catch {}
}

export function dequeueSync(endpoint) {
  try {
    const q = getQueue();
    delete q[endpoint];
    localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
  } catch {}
}

export function hasQueued() {
  return Object.keys(getQueue()).length > 0;
}

export function queueCount() {
  return Object.keys(getQueue()).length;
}
